module.exports = __webpack_public_path__ + "img/share set.ad50db45.svg";